import { api } from '../../../../api';
import type { Id } from '../../../../api/types';

export function setupConnectionSync(
  editor: any,
  connectionMap: Map<number, any>,
  getWorkflowId: () => Id | undefined,
  isSyncing: () => boolean
) {
  editor.addPipe(async (ctx: any) => {
    if (isSyncing()) return ctx;
    const currentWorkflowId = getWorkflowId();
    if (ctx.type === 'connectioncreated' && currentWorkflowId) {
      const c: any = ctx.data;
      const sourceNode: any = editor.getNode?.(c.source);
      const targetNode: any = editor.getNode?.(c.target);
      const payload = {
        fromId: Number(sourceNode?.apiId ?? c.source),
        toId: Number(targetNode?.apiId ?? c.target),
        fromField: String(c.sourceOutput),
        toField: String(c.targetInput),
      };
      try {
        if (c.apiId) {
          const updated = await api.workflows.updateConnection(
            currentWorkflowId,
            c.apiId,
            payload
          );
          c._kvName = updated.name;
          connectionMap.set(c.apiId, c);
        } else {
          const saved = await api.workflows.createConnection(
            currentWorkflowId,
            payload
          );
          c.apiId = saved.id;
          c._kvName = saved.name;
          connectionMap.set(saved.id, c);
        }
      } catch (e) {
        // API rejected the connection (e.g., 400 Bad Request). Roll back UI.
        console.error(
          'Failed to persist connection. Rolling back UI change.',
          e
        );
        try {
          // Removing by internal id avoids triggering API delete because c.apiId is undefined on failure
          const connectionId = (c as any).id;
          if (connectionId != null) {
            await editor.removeConnection(connectionId);
          } else {
            // Fallback: try removing by object reference
            await editor.removeConnection(c);
          }
        } catch (removeErr) {
          console.error(
            'Failed to rollback (remove) invalid connection:',
            removeErr
          );
        }
      }
    }
    if (ctx.type === 'connectionremoved' && currentWorkflowId) {
      const c: any = ctx.data;
      if (c.apiId) {
        try {
          await api.workflows.deleteConnection(currentWorkflowId, c.apiId);
          connectionMap.delete(c.apiId);
        } catch (e) {
          console.error('❌ Failed to delete connection:', e);
        }
      }
    }
    return ctx;
  });
}
